import * as React from 'react'

export function useIsReady() {
  const [isAxeptioReady, setIsAxeptioReady] = React.useState(false)

  // Axeptio add a callback function inside the array using the push() method.
  // The inner part of the function will be executed only once Axeptio script
  // is loaded and when the project's configuration has been fetched
  if (typeof window !== 'undefined') {
    window._axcb?.push(function () {
      if (!isAxeptioReady) {
        setIsAxeptioReady(true)
      }
    })
  }

  return isAxeptioReady
}
